'use client'

import {FC, useEffect} from 'react'

import {renewChoices} from '@/utils/preferences/choices'

/**
 * Refreshes the expiry of the visitor's choice cookies once per page load. Placed ahead of the
 * providers in the shell, so its effect runs before anything on the page reads or writes a choice.
 */
export const ChoiceCookiesExpirationRefresh: FC = () => {
  useEffect(() => {
    renewChoices()
  }, [])

  return null
}
